<template>
    <div class="staking-pair-config-box">
        <div style="float: left">
            <el-select v-model="status" @change="handleStatusChange($event)" placeholder="状态">
                <el-option label="全部" value="ALL"></el-option>
                <el-option label="上架" value="true"></el-option>
                <el-option label="下架" value="false"></el-option>
            </el-select>
        </div>
        <div class="preview-opration">
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreatePairDialog">新增
            </el-button>
        </div>
        <div class="pair-list">
            <el-table class="pair-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="pairList" :row-key="() => Math.random()">
                <el-table-column prop="sortNum" label="序号"></el-table-column>
                <el-table-column prop="coinType" label="币种类型"></el-table-column>
                <el-table-column prop="incomeCoinList" label="收益币种"></el-table-column>
                <el-table-column prop="unlockCoinType" label="解锁币种"></el-table-column>
                <el-table-column prop="unlockMultiplier" label="解锁乘数"></el-table-column>
                <el-table-column prop="lockMax" label="锁仓最大值" show-overflow-tooltip></el-table-column>
                <el-table-column prop="lockMin" label="锁仓最小值" show-overflow-tooltip></el-table-column>
                <el-table-column prop="precisions" label="精度" show-overflow-tooltip></el-table-column>
                <el-table-column prop="annualizedIncome" label="预期年化收益" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unlockDaysMiningPool" label="矿池解锁周期" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unlockDaysPlatform" label="平台解锁周期" show-overflow-tooltip></el-table-column>
                <el-table-column prop="supportLock" label="是否支持锁仓" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.supportLock?"是":"否"}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="eth2" label="是否是eth2.0" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.eth2?"是":"否"}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="onShelf" label="上架状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.onShelf?"上架":"下架"}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lockCycleType" label="锁仓期限类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.lockCycleType | formatlockCycleType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="startIncomeDays" label="预计多少天后开始收益" show-overflow-tooltip></el-table-column>
                <el-table-column label="锁仓开始时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.beginTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="上下架修改时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.onShelfUpdateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="修改时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="updatePairDialog(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="params.page"
                           :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                           :page-size="params.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="pairData" :rules="pairRules" ref="pairForm">
                <el-form-item label="排序号：" prop="sortNum" style="padding-top: 20px">
                    <el-input-number v-model="pairData.sortNum" :min="1" :max="10000000" label="排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="币种：" prop="coinType" style="padding-top: 20px">
                    <el-input v-model="pairData.coinType" placeholder="币种" style="width: 215px"></el-input>
                </el-form-item>
                <el-form-item label="挖矿币种：" prop="incomeCoinList" style="padding-top: 20px">
                    <div>
                        <el-tag :key="coinStr" v-for="coinStr in selectCoinList" closable :disable-transitions="false"
                                @close="handleClose(coinStr)" style="margin-right: 20px;margin-bottom: 20px">
                            {{coinStr}}
                        </el-tag>
                        <el-button class="button-new-tag" size="small" @click="addIncomeCoin">+ 挖矿币种
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="解锁币种：" prop="unlockCoinType" style="padding-top: 20px">
                    <el-input v-model="pairData.unlockCoinType" placeholder="解锁币种" style="width: 215px"></el-input>
                </el-form-item>
                <el-form-item label="解锁乘数：" prop="unlockMultiplier" style="padding-top: 20px">
                    <el-input v-model="pairData.unlockMultiplier" placeholder="解锁乘积" style="width: 215px"></el-input>
                </el-form-item>
                <el-form-item label="锁仓期限类型：" style="padding-top: 20px">
                    <el-select v-model="pairData.lockCycleType" placeholder="锁仓期限类型">
                        <el-option v-for="item in lockCycleTypeOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="锁仓开始时间：" prop="beginTime" style="padding-top: 20px">
                    <el-date-picker v-model="pairData.beginTime" type="datetime" placeholder="锁仓开始时间"
                                    value-format="timestamp"></el-date-picker>
                </el-form-item>
                <el-form-item label="是否支持锁仓：" prop="supportLock" style="padding-top: 20px">
                    <el-switch v-model="pairData.supportLock" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="是否上架：" prop="onShelf" style="padding-top: 20px">
                    <el-switch v-model="pairData.onShelf" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="锁仓最小量：" prop="lockMin" style="padding-top: 20px">
                    <el-input v-model="pairData.lockMin" placeholder="锁仓最小量" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="锁仓最大量：" prop="lockMax" style="padding-top: 20px">
                    <el-input v-model="pairData.lockMax" placeholder="锁仓最大量" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="锁仓小数精度：" prop="precisions" style="padding-top: 20px">
                    <el-input v-model="pairData.precisions" placeholder="锁仓小数精度" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="预期年化收益：" prop="annualizedIncome" style="padding-top: 20px">
                    <el-input v-model="pairData.annualizedIncome" placeholder="预期年化收益" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="矿池解锁周期：" prop="unlockDaysMiningPool" style="padding-top: 20px">
                    <el-input v-model="pairData.unlockDaysMiningPool" placeholder="矿池解锁周期"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="平台解锁周期：" prop="unlockDaysPlatform" style="padding-top: 20px">
                    <el-input v-model="pairData.unlockDaysPlatform" placeholder="平台解锁周期"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="简介：" style="padding-top: 20px">
                    <div v-for="lang in languages" :key="lang.value" class="introduction-editor">
                        <div class="introduction-editor-header">{{ lang.label }}简介 （最多500个字符）</div>
                        <el-input :value="description[lang.value]" type="textarea" :rows="6" maxlength="500"
                                  @change="handleEditorChange(lang.value, $event)"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="是否eth2.0：" prop="eth2" style="padding-top: 20px">
                    <el-switch v-model="pairData.eth2" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addOrUpdatePair">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="选择挖矿币种" :visible.sync="selectCoinDialogVisible" width="400px"
                   :close-on-click-modal="false">
            <el-form>
                <el-form-item label="币种">
                    <el-autocomplete class="inline-input"
                                     v-model="selectCoinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种"
                                     @select="handleSelect"
                                     @keyup.native.enter="handleSearch">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="selectCoin">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import Editor from "components/editor";
    import LANGUAGES from "../common/languages_code";

    export default {
        name: 'PairConfig',
        components: {
            Editor
        },
        data() {
            return {
                pairList: [],
                total: 0,
                status: "ALL",
                dialogVisible: false,
                dialogTitle: "新增",
                currOpration: "1", //1-新增，2-修改
                loading: false,
                params: {onShelf: null, page: 1, size: 10},
                pairData: {
                    id: "",
                    coinType: "",
                    descriptionJson: "",
                    lockMin: "",
                    lockMax: "",
                    precisions: "",
                    annualizedIncome: "",
                    unlockDaysMiningPool: "",
                    unlockDaysPlatform: "",
                    supportLock: true,
                    onShelf: true,
                    sortNum: 1,
                    beginTime: "",
                    lockCycleType: 1,
                    incomeCoinList: "",
                    unlockCoinType: "",
                    unlockMultiplier: 1,
                    eth2: false
                },
                pairRules: {
                    "coinType": [{required: true, message: "币种不能为空"}],
                    "incomeCoinList": [{required: true, message: "挖矿币种不能为空"}],
                    "lockMin": [{required: true, message: "锁仓最小量不能为空"}],
                    "lockMax": [{required: true, message: "锁仓最大量不能为空"}],
                    "precisions": [{required: true, message: "锁仓小数精度不能为空"}],
                    "annualizedIncome": [{required: true, message: "预期年化收益不能为空"}],
                    "unlockDaysMiningPool": [{required: true, message: "矿池解锁周期不能为空"}],
                    "unlockDaysPlatform": [{required: true, message: "平台解锁周期不能为空"}],
                    "supportLock": [{required: true, message: "支持锁仓不能为空"}],
                    "onShelf": [{required: true, message: "是否上架不能为空"}],
                    "sortNum": [{required: true, message: "排序号不能为空"}],
                    "beginTime": [{required: true, message: "锁仓开始时间不能为空"}],
                    "lockCycleType": [{required: true, message: "锁仓类型不能为空"}],
                    "unlockCoinType": [{required: true, message: "解锁币种不能为空"}]
                },
                lockCycleTypeOptions: [{value: 1, label: "灵活解锁"}],
                languages: Object.keys(LANGUAGES).map(lang => ({
                    label: LANGUAGES[lang],
                    value: lang
                })),
                description: {},
                selectCoinList: [],
                coinTypes: [],
                selectCoinType: "",
                selectCoinDialogVisible: false
            }
        },
        filters: {
            formatlockCycleType(type) {
                switch (type) {
                    case 1:
                        return "灵活解锁";
                    default:
                        return type;
                }
            }
        },
        methods: {
            handleStatusChange(value) {
                this.params.page = 1;
                this.params.onShelf = value == "ALL" ? null : (value == "true" ? true : false);
                this.getPairList(this.params);
            },
            getPairList(query) {
                api.getStakingCoinList(query).then(({data}) => {
                    this.total = data.totalCount;
                    this.pairList = data.list;
                });
            },
            openCreatePairDialog() {
                this.dialogTitle = "新增";
                this.currOpration = "1"; //1-新增，2-修改
                this.pairData.sortNum = this.total + 1;
                this.dialogVisible = true;
            },
            updatePairDialog(row) {
                this.pairData = {
                    id: row.id,
                    coinType: row.coinType,
                    descriptionJson: row.descriptionJson,
                    lockMin: row.lockMin,
                    lockMax: row.lockMax,
                    precisions: row.precisions,
                    annualizedIncome: row.annualizedIncome,
                    unlockDaysMiningPool: row.unlockDaysMiningPool,
                    unlockDaysPlatform: row.unlockDaysPlatform,
                    supportLock: row.supportLock,
                    onShelf: row.onShelf,
                    sortNum: row.sortNum,
                    beginTime: row.beginTime,
                    lockCycleType: row.lockCycleType,
                    incomeCoinList: row.incomeCoinList,
                    unlockCoinType: row.unlockCoinType,
                    unlockMultiplier: row.unlockMultiplier,
                    eth2: row.eth2
                };
                this.description = row.descriptionJson ? JSON.parse(row.descriptionJson) : {};
                this.selectCoinList = row.incomeCoinList ? JSON.parse(row.incomeCoinList) : [];
                this.dialogTitle = "修改";
                this.currOpration = "2"; //1-新增，2-修改
                this.dialogVisible = true;
            },
            addOrUpdatePair() {
                this.pairData.incomeCoinList = JSON.stringify(this.selectCoinList);
                this.$refs["pairForm"].validate(valid => {
                    if (valid) {
                        if (this.currOpration == "1") {
                            api.createStakingCoin(this.pairData).then(() => {
                                this.$message.success("创建成功！");
                                this.getPairList(this.params);
                                this.dialogVisible = false;
                            });
                        } else if (this.currOpration == "2") {
                            api.updateStakingCoin(this.pairData).then(() => {
                                this.$message.success("修改成功！");
                                this.getPairList(this.params);
                                this.dialogVisible = false;
                            });
                        }
                    }
                });
            },
            handleEditorChange(lang, value) {
                this.description[lang] = value;
                this.pairData.descriptionJson = JSON.stringify(this.description);
            },
            handleSizeChange(val) {
                this.params.size = val;
                this.getPairList(this.params);
            },
            handleCurrentChange(val) {
                this.params.page = val;
                this.getPairList(this.params);
            },
            initData() {
                Object.keys(LANGUAGES).map(lang => {
                    this.description[lang] = "";
                })
            },
            addIncomeCoin() {
                this.selectCoinDialogVisible = true;
            },
            selectCoin() {
                if (this.selectCoinList.indexOf(this.selectCoinType) != -1) {
                    this.$message.error("币种已存在！");
                    return
                }
                this.selectCoinList.push(this.selectCoinType);
                this.pairData.incomeCoinList = JSON.stringify(this.selectCoinList);
                this.selectCoinDialogVisible = false;
            },
            handleClose(coinStr) {
                this.selectCoinList.splice(this.selectCoinList.indexOf(coinStr), 1);
                this.pairData.incomeCoinList = JSON.stringify(this.selectCoinList);
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.selectCoinType = '';
            },
            handleSearch() {

            },
            handleSelect() {
            },
            clearData() {
                this.dialogVisible = false;
                this.dialogTitle = "新增";
                this.currOpration = "1";//1-新增，2-修改
                this.loading = false;
                this.selectCoinList = [];
                this.pairData = {
                    id: "",
                    coinType: "",
                    descriptionJson: "",
                    lockMin: "",
                    lockMax: "",
                    precisions: "",
                    annualizedIncome: "",
                    unlockDaysMiningPool: "",
                    unlockDaysPlatform: "",
                    supportLock: true,
                    onShelf: true,
                    sortNum: 1,
                    beginTime: "",
                    lockCycleType: 1,
                    unlockCoinType: "",
                    unlockMultiplier: 1,
                    eth2: false
                };
                this.initData();
            }
        },
        created() {
            this.initData();
            this.getPairList(this.params);
            this.getAllSupportCoin();
        }
    };
</script>

<style lang="less" scoped>
    .staking-pair-config-box {
        .preview-opration {
            float: right;
        }

        .pair-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .pair-table {
                margin-top: 30px;
            }
        }
    }
</style>

